module.exports = __webpack_public_path__ + "img/landing_code_wb.b3220d2e.png";